export default {
	phone_call_ai_summary: 'Zusammenfassung',
	phone_call_ai_summary_label: 'KI-Zusammenfassung',
	phone_call_by: 'durch',
	phone_call_call: 'Anrufen',
	phone_call_call_back: 'Zurückrufen',
	phone_call_call_incoming: 'Eingehender Anruf',
	phone_call_call_label: 'Anruf',
	phone_call_call_outgoing: 'Ausgehender Anruf',
	phone_call_callback_request_field_label: 'Rückrufwunsch',
	phone_call_caller_name_add_label: 'Neuen Anrufername erstellen',
	phone_call_caller_name_apply_label: 'Übernehmen',
	phone_call_caller_name_cancel_label: 'Abbrechen',
	phone_call_caller_name_edit_label: 'Anrufername bearbeiten',
	phone_call_caller_name_label: 'Anrufername',
	phone_call_caller_number_label: 'Rufnummer',
	phone_call_contact_picture_action_label: 'Kontaktbild bearbeiten',
	phone_call_contact_picture_cancel_label: 'Abbrechen',
	phone_call_contact_picture_current_alt: 'Aktuelles Kontaktbild',
	phone_call_contact_picture_dialog_title: 'Kontaktbild für Anrufer bearbeiten',
	phone_call_contact_picture_drop_hint: 'Bild hierher ziehen',
	phone_call_contact_picture_google_search_label: 'Google-Bildersuche',
	phone_call_contact_picture_invalid_file_error: 'Bitte eine Bilddatei auswählen.',
	phone_call_contact_picture_preview_alt: 'Vorschau des neuen Kontaktbilds',
	phone_call_contact_picture_preview_empty: 'Noch kein Bild ausgewählt.',
	phone_call_contact_picture_preview_label: 'Vorschau',
	phone_call_contact_picture_remove_confirm_cancel_label: 'Abbrechen',
	phone_call_contact_picture_remove_confirm_message: 'Das Kontaktbild wird für diese Rufnummer entfernt.',
	phone_call_contact_picture_remove_confirm_ok_label: 'Entfernen',
	phone_call_contact_picture_remove_confirm_title: 'Kontaktbild entfernen?',
	phone_call_contact_picture_remove_error: 'Das Kontaktbild konnte nicht entfernt werden.',
	phone_call_contact_picture_remove_label: 'Kontaktbild entfernen',
	phone_call_contact_picture_remove_success: 'Kontaktbild wurde entfernt',
	phone_call_contact_picture_replace_label: 'Anderes Bild wählen',
	phone_call_contact_picture_save_error: 'Das Kontaktbild konnte nicht gespeichert werden.',
	phone_call_contact_picture_save_label: 'Speichern',
	phone_call_contact_picture_save_success: 'Kontaktbild wurde gespeichert',
	phone_call_contact_picture_source_upload_label: 'Bild auswählen',
	phone_call_contact_picture_target_label: 'Kontakt',
	phone_call_details_call_accepted_by_label: 'angenommen durch',
	phone_call_details_call_duration_label: 'Dauer',
	phone_call_details_call_extension_label: 'Durchwahl',
	phone_call_details_call_list_label: 'Anrufliste',
	phone_call_details_call_minutes_label: 'Minuten',
	phone_call_details_tab_label: 'Details',
	phone_call_for: 'für',
	phone_call_hangup: 'Auflegen',
	phone_call_history_tab_label: 'Historie',
	phone_call_info_tab_label: 'Info',
	phone_call_initialize_phone_call: 'Initialisiere Anruf an',
	phone_call_open_the_phone_book: 'Telefonbuch öffnen',
	phone_call_outgoing_call: 'Ausgehender Anruf',
	phone_call_page_of: "von {'{'}totalPages{'}'}",
	phone_call_page_report: 'Anzeige Eintrag {first} - {last} von {totalRecords}',
	phone_call_phone_book_duplicates_empty: 'Keine Duplikate gefunden',
	phone_call_phone_book_edit_cancel: 'Abbrechen',
	phone_call_phone_book_edit_name: 'Namen bearbeiten',
	phone_call_phone_book_edit_save: 'Speichern',
	phone_call_phone_book_empty: 'Keine Telefonbucheinträge',
	phone_call_phone_book_ignore_entry_question: 'Ignorieren',
	phone_call_phone_book_ignored_entry: 'Ignorierter Eintrag',
	phone_call_phone_book_loading: 'Telefonbuch wird geladen...',
	phone_call_phone_book_merge: 'Übernehmen',
	phone_call_phone_book_merge_notification: 'Verarbeite die Auswahl',
	phone_call_phone_book_phone_book_tab_label: 'Telefonbuch',
	phone_call_phone_book_phone_call: 'Anruf',
	phone_call_phone_book_phone_calls: 'Anrufe',
	phone_call_phone_book_phonetic_duplicates_cleaner_tab_label: 'Duplikate',
	phone_call_phone_book_save_notification: 'Aktualisiere den Eintrag',
	phone_call_phone_book_tab_manager_tab_label: 'Telefonbuch',
	phone_call_phone_book_table_header_search_placeholder: 'Suche',
	phone_call_phone_table_name_column_label: 'Name',
	phone_call_phone_table_number_column_label: 'Nummer',
	phone_call_print: 'Drucken',
	phone_call_reason_label: 'Anrufgrund',
	phone_call_reverse_number_search: 'Rückwärtssuche',
	phone_call_save_failed_notification: 'Der Anruf konnte nicht gespeichert werden',
	phone_call_saved_notification: 'Der Anruf wurde gespeichert',
	phone_call_spam_check: 'Spamcheck',
	phone_call_time_label: 'Uhr',
	phone_call_with_callback_request: 'mit Rückrufbitte',
	phone_call_without_callback_request: 'ohne Rückrufbitte',
};
